<div (click)="download()"><ng-content></ng-content></div>
